import React from 'react'
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles'

const LaunchMailerModal = ({ close_icon, icon , title , launch = false, description, confetti, onPass, onClose = () => {}, onSave = () => {} }) => {
  
   return (
    <> 
    <div
      className={`fixed z-20 left-0 top-16 overflow-y-auto`}
      style={{width: '100%'}}
    >
      <div className='flex items-end justify-center text-center mb'>
        <div 
          className="inline-block align-bottom bg-white rounded-lg overflow-hidden shadow-xl transform" 
          style={{width: '100%', height: '100vh'}}
        >
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" 
          style={{backgroundImage: `url(${confetti})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}
          >
            <div className='flex flex-row-reverse pr-4'>
              <img src={close_icon} alt='closeIcon' className='cursor-pointer' onClick={onClose}/>
            </div>   
              <div className="text-center sm:mt-32 sm:mx-4 grid justify-items-center mb-72">
                  { !launch && <img src={icon} style={{width: '200px', height: '200px', color: '#4B5563'}} className='m-4 mb-14'/>}
                  <div className='text-5xl leading-10 my-2.5 font-bold'>
                      {title}
                  </div>    
                  <div className='my-4 text-xl font-normal w-2/3 leading-8' style={{color: '#475569'}}>
                      {description}
                  </div> 
              <div className="px-4 p-3 flex justify-center">
            { launch &&
            <div className='my-16 mt-8'>
              <button 
                onClick = {onSave} 
                className={joinButtonClasses(dsButtonPrimary, 'mx-2 h-auto px-40 py-12 text-5xl leading-5')}
              >
                {onPass}
              </button>
            </div>}
            </div>
            {launch &&
            <div className='absolute bottom-20'>
              <hr className='w-screen'/>
              <p className='py-3 text-base'>A detailed email will be sent to your employees describing the health benefits they will receive.</p>
            </div>}
          </div>
          </div>
        </div>
      </div>
    </div> 
   </>   
  )
}

export default LaunchMailerModal;
